const NODE_NOT_CHILD_RE =
  /\b(?:node to be removed is not a child|node before which the new node is to be inserted is not a child)\b/iu;

const isNodeNotChildError = (error) =>
  error?.name === "NotFoundError" || NODE_NOT_CHILD_RE.test(error?.message || "");

const recordGuardedMutation = ({ addBreadcrumb, method }) => {
  try {
    addBreadcrumb?.({
      category: "dom",
      message: "guarded_external_dom_mutation",
      data: { method },
    });
  } catch (error) {
    // Crash hardening must never become another boot dependency.
  }
};

export const installDomMutationGuard = ({
  nodePrototype = typeof Node !== "undefined" ? Node.prototype : null,
  addBreadcrumb = null,
} = {}) => {
  if (!nodePrototype || nodePrototype.__linkedLivesDomMutationGuardInstalled) {
    return false;
  }

  const originalRemoveChild = nodePrototype.removeChild;
  const originalInsertBefore = nodePrototype.insertBefore;

  if (
    typeof originalRemoveChild !== "function" ||
    typeof originalInsertBefore !== "function"
  ) {
    return false;
  }

  Object.defineProperty(nodePrototype, "__linkedLivesDomMutationGuardInstalled", {
    configurable: true,
    value: true,
  });

  nodePrototype.removeChild = function guardedRemoveChild(child) {
    try {
      return originalRemoveChild.call(this, child);
    } catch (error) {
      if (isNodeNotChildError(error) && child?.parentNode !== this) {
        recordGuardedMutation({ addBreadcrumb, method: "removeChild" });
        return child;
      }
      throw error;
    }
  };

  nodePrototype.insertBefore = function guardedInsertBefore(newNode, referenceNode) {
    try {
      return originalInsertBefore.call(this, newNode, referenceNode);
    } catch (error) {
      if (isNodeNotChildError(error) && referenceNode?.parentNode !== this) {
        recordGuardedMutation({ addBreadcrumb, method: "insertBefore" });
        return this.appendChild(newNode);
      }
      throw error;
    }
  };

  return true;
};
